<script>
  import Item from './Item.svelte';
  import Wysiwyg from '$lib/default/Wysiwyg.svelte';

  export let solutions;
  export let wysiwyg;
</script>

<section class="solutions">
  <div class="container">
    <Wysiwyg content={wysiwyg.content} />

    <!-- <h2 class="solutions__title">{solutions.title}</h2>
    <p class="solutions__desc text-small">{solutions.desc}</p> -->
    <div class="solutions__items flexbox">
      {#each solutions.items as item}
        <div class="solutions__oneItem col col-33 col-m-50 col-s-full">
          <Item {item} />
        </div>
      {/each}
    </div>
  </div>
</section>

<style lang="scss">
  .solutions {
    &__items {
      margin-top: 5rem;
      row-gap: 3.4rem;
    }
  }
</style>
